var path = 'areas/projects/views/azure_service_fabric_sdk_required_info.html';
var html = "<div class=\"alert alert-info form-group-narrow\"> <p> The <a class=alert-link target=_blank href=https://g.octopushq.com/ServiceFabricSdkDownload>Service Fabric SDK</a> must be installed on the <strong>Octopus Server</strong> for this step. Additional information about this step can be found in the <a class=alert-link target=_blank href=http://g.octopushq.com/ServiceFabricDeployingApps>Deploying to Service Fabric documentation</a>. </p> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/views/azure_service_fabric_sdk_required_info.html
// module id = 4492048414713868
// module chunks = 1